export class GetSkuMapError extends Error {
  constructor(error, choices) {
    super(error.message);
    this.name = 'GetSkumapError';
    this.originalError = error;
    this.response = error.response;
    this.choices = choices;
  }
}